export enum ExamTypeEnum {
  Предрейсовый,
  Предсменный,
  Послерейсовый,
  Послесменный,
}

export enum GenderTypeEnum {
  Мужской,
  Женский,
}

export enum EnumRoles {
  Обследуемый = "Обследуемый",
  Руководитель = "Руководитель",
  Врач = "Врач",
  Админ = "Админ",
  Механик = "Механик",
  Сотрудник = "Сотрудник поликлиники",
}

export enum EnumEducationType {
  "Специалитет",
  "Интернатура",
  "Ординатура",
  "Аспирантура",
  "Повышение квалификации",
  "Бакалавриат",
  "Магистратура",
}

export interface IDecoded {
  UserId: number;
  PersonId: number | null;
  Role: EnumRoles | EnumRoles[];
  exp: number;
}

export type TypeRole = EnumRoles | EnumRoles[];

export type TypeStringNullUndefined = string | null | undefined;
export type TypeNumberNullUndefined = number | null | undefined;

export type statusType = "pending" | "loading" | "success" | "failure";

export type SortType = "descend" | "ascend" | "default";

export enum NotificationTypeEnum {
  "Обновление ПО",
  "Новое заключение",
  "Новый осмотр",
  "Пропало подключение",
  "Запрос на фото",
  "Фото утверждено",
  "Фото отклонено",
}

export enum FileTypeEnum {
  "Фото осмотра",
  "Видео осмотра",
  "Аудио оценки речи",
  "Фото профиля физ. лица",
  "PDF заключения",
  "Подпись заключения",
  "Сборка клиентского приложения",
  "Файл лицензии",
  "Отчёт об ошибках импорта",
  "Остальные файлы",
}

export interface INotification {
  id: number;
  title: string;
  description: string;
  time: string;
  examId?: number;
  personId?: number;
  ownPersonId: number;
  status: "new" | "viewed";
  type: number;
}

export type TypeNewExam = {
  Title: string;
  Body: string;
  ExamId?: number;
  PersonId?: number;
};

export type RangeData = {
  id?: number;
  patientId?: number;
  systLower?: number;
  systUpper?: number;
  diastLower?: number;
  diastUpper?: number;
  pulseLower?: number;
  pulseUpper?: number;
  luminosityLower?: number;
  luminosityUpper?: number;
  temperatureLower?: number;
  temperatureUpper?: number;
  moistureLower?: number;
  moistureUpper?: number;
};

export enum MinStartDateEnum {
  AllTime = 0, // 0 - за все время
  HalfYear = 4, // 4 - за полгода
  Month = 3, // 3 - за месяц
  Week = 2, // 2 - за неделю
  Today = 1, // 1 - за сегодня
}

export enum ExamStatusesEnum {
  InProcess = 10,
  SendingMediaFiles = 20,
  Open = 30,
  LeftTimeConclusion = 35,
  Unsigned = 40,
  LeftTimeSign = 45,
  Closed = 50,
  Failed = 300,
}
